import React, {useEffect, useState} from "react"
import {InputBox, Modal, notification,} from "../../../components/Elements/appUtils";
import axios from "axios";
import {getbatchRecordByProductIdUrl} from "../api";
import {getToken} from "../../../request";

const UpdateDiscount = (props) => {
    let {onClose, data, visible, index, onSubmit} = props;
    let [discount, setDiscount] = useState(0);
    let [quantity, setQuantity] = useState(0);
    let [batch, setBatch] = useState([]);
    let [selectedBatch, setSelectedBatch] = useState(data);
    useEffect(() => {
        if (data.discount) {
            setDiscount(data.discount)
        }
        if (data.quantity) {
            setQuantity(data.quantity)
        }
        setSelectedBatch(data)
        fetchBatch()
    }, [data]);

    const chooseBatch = (batchData) => {
        if (batchData.quantity) {
            setSelectedBatch((prevData) => {
                return {
                    ...prevData,
                    batchQuantity: batchData.quantity,
                    batchId: batchData._id,
                    batchNo: batchData.batchNo,
                    price: batchData.salePrice ? batchData.salePrice : 0,
                    manufacturingDate: batchData.manufacturingDate,
                    expiryDate: batchData.expiryDate,
                    salePrice: batchData.salePrice
                }
            })
            setQuantity(1);
        } else {
            notification.warning({
                message: "Quantity not exists in this batch.",
            });
        }
    }


    const fetchBatch = async () => {
        let productId = data.productId;
        try {
            const response = await axios.get(getbatchRecordByProductIdUrl(), {
                params: {productId},
                ...(await getToken()),
            });
            setBatch(response.data.data);
        } catch (error) {
            console.error("Error getting the data:", error);
        }
    };

    const submitFxn = () => {
        if (quantity > selectedBatch.BatchQunatity) {
            notification.warning({
                message: `Please enter valid quantity, Batch Quantity - ${selectedBatch.BatchQunatity}`,
            });
            return
        }
        onSubmit(index, {
            ...selectedBatch,
            batchQuantity: selectedBatch.BatchQunatity,
            discount: (discount || 0),
            quantity: (quantity || 0)
        })
    }

    return (
        <Modal title={'Update Discount'}
               visible={visible}
               width={'42%'}
               onClose={onClose}>
            <div className={'row'}>
                <div className={'col-md-6'}>
                    <InputBox title={'Quantity'}>
                        <input value={quantity}
                               type={'number'}
                               className={'form-control'} onChange={({target}) => {
                            setQuantity(target.value)
                        }}/>
                    </InputBox>
                </div>
                <div className={'col-md-6'}>
                    <InputBox title={'Discount'}>
                        <input value={discount}
                               type={'number'}
                               className={'form-control'} onChange={({target}) => {
                            setDiscount(target.value)
                        }}/>
                    </InputBox>
                </div>
                <div className={'col-md-12'}>
                    <br/>
                    <br/>
                    <table className="table table-bordered">
                        <thead>
                        <tr>
                            <td>Batch Number</td>
                            <td>Mfg Date</td>
                            <td>Exp Date</td>
                            <td>Quantity</td>
                            <td>Action</td>
                        </tr>
                        </thead>
                        <tbody>
                        {batch.map((item) => (
                            <tr key={item.id}>
                                <td>{item.batchNo}</td>
                                <td>{item.manufacturingDateString}</td>
                                <td>{item.expiryDateString}</td>
                                <td>{item.quantity}</td>
                                <td>
                                    <button
                                        onClick={() => {
                                            chooseBatch(item)
                                        }}
                                        className={`btn ${item._id == selectedBatch.batchId ? "btn-info" : "btn-default-new"}  btn-xs rounded`}>
                                        {item._id == selectedBatch.batchId ? "Selected" : "Select"}
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

            </div>


            <div className={'mt-3 align-right'}>
                <button type="submit" className="btn btn-gradient-info me-2" onClick={() => {
                    submitFxn();
                }}>
                    Update
                </button>
            </div>

        </Modal>
    )
}
export default UpdateDiscount